import {Action, getModule, Module, MutationAction, VuexModule, Mutation} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import { ICashboxSettings, ICashboxSettingsListItem, CashboxSettingsResponseType } from '@/entity/finance/cashbox/cashboxSettings.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { PaymentSettingsRequestType } from '@/form/Settings/finances/pyment.type';
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'cashboxSettings',
    store,
    dynamic: true,
})
class CashboxSettingsModule extends VuexModule {
    cashBoxSettings: ICashboxSettings | null = null;
    cashBoxSetting: ICashboxSettingsListItem | null = null;
    cashBoxSettingsLoaded = false;
    cashBoxSettingLoaded = false;
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ cashBoxSettings: ICashboxSettings; cashBoxSettingsLoaded: boolean }> {
        let cashBoxSettingsLoaded = false;
        console.log('cashBoxesLoaded query vuex - ')

        const cashBoxSettings = await store.$repository.settingsCashBox.fetchAll(prepareFormData(data));
        if (cashBoxSettings) {
            cashBoxSettingsLoaded = true;
        }
        return {cashBoxSettings, cashBoxSettingsLoaded};
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ cashBoxSetting: ICashboxSettingsListItem; cashBoxSettingLoaded: boolean }> {
        console.log('Client query vuex fetch Data - ')
        let cashBoxSettingLoaded = false;
        const cashBoxSetting = await store.$repository.settingsCashBox.fetchData(data);
        if (cashBoxSetting) {
            cashBoxSettingLoaded = true;
        }
        return { cashBoxSetting, cashBoxSettingLoaded };
    }

    @Action({rawError: true})
    async create(data: PaymentSettingsRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.settingsCashBox.create(data);
        return resp;
    }

    @Action({rawError: true})
    async update(data: PaymentSettingsRequestType): Promise<ResponseDataType> {
        return await store.$repository.settingsCashBox.update(data)
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return  await store.$repository.settingsCashBox.delete(data)
    }
}

export const CashboxSettingsStore = getModule(CashboxSettingsModule);
